import axios from 'axios';
import config, { environment } from './config';

const AxiosInstance = axios.create();

AxiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('jwtAccessToken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

AxiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            // Check if we are already redirecting to login to avoid loops/multiple redirects
            if (window.location.pathname === '/login') {
                return Promise.reject(error);
            }

            originalRequest._retry = true;
            const refreshToken = localStorage.getItem('jwtRefreshToken');

            if (refreshToken) {
                try {
                    const response = await axios.post(config[environment].refreshTokenEndpoint, {
                        refresh: refreshToken
                    });

                    if (response.status === 200) {
                        const newAccessToken = response.data.access;
                        localStorage.setItem('jwtAccessToken', newAccessToken);
                        localStorage.setItem('token', newAccessToken);

                        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                        return AxiosInstance(originalRequest);
                    }
                } catch (refreshError) {
                    console.error('Token refresh failed:', refreshError);
                    clearAuthData();
                }
            } else {
                // No refresh token available, clear everything and redirect
                clearAuthData();
            }
        }
        return Promise.reject(error);
    }
);

let isRedirecting = false;
function clearAuthData() {
    if (isRedirecting) return;
    isRedirecting = true;

    localStorage.removeItem('jwtAccessToken');
    localStorage.removeItem('jwtRefreshToken');
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('userUsername');
    localStorage.removeItem('userEmail');
    
    // Redirect to login
    window.location.href = '/login';
}

export default AxiosInstance;
